<template>
  <div class="center">
    <h4 class="title title--5 primary">
      <span class="icon icon--inline far fa-lock-alt" />
      Your group order is locked.
    </h4>

    <p>
      {{ order.groupOrder.host.displayName }} is currently checking out. If you'd like to make changes to your cart, please ask {{ order.groupOrder.host.displayName }} to exit the checkout process.
    </p>
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'GroupOrderLockedMessage',

    computed: {
      ...mapGetters('orders', ['order'])
    }
  };
</script>
